//@import dependencies
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {AiFillCloseCircle} from 'react-icons/ai'
import { useForm } from 'react-hook-form'
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IUserListItem } from 'app_types/admin/user/userTypes'
import { ICompanyListItem } from 'app_types/admin/company/companyTypes'
// @end

// @INFO Import services
import UserService from 'app_services/user/userService'
import ReactSelectService from 'app_services/components/reactSelectService'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @INFO Import Styles
import './../modalCompanyUsersModule.scss'
import SwitchComponent from 'app_components/commons/switch'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { IUserData } from 'app_types/userTypes';

// @ADD Component types
interface IAddNewCompanyFormModuleProps {
  company: ICompanyListItem
  users: IUserListItem[]
  editData?: IUserData
  handleClose: (data: any) => void
}

const AddNewCompanyFormModuleLayout: React.FC<IAddNewCompanyFormModuleProps> = (props) => {

  const screenNotifications: ScreenNotificationsUtil = new ScreenNotificationsUtil()
  const userService: UserService = new UserService()
  const reactSelectService: ReactSelectService = new ReactSelectService()

  const { t } = useTranslation()
  const [colors] = useColors()

  const formHook = useForm()

  const [processing, setProcessing] = useState<boolean>(false)
  const [listOfUsers, setListOfUsers] = useState<{value: string, label: string}[]>([])
  const [superUser, setSuperUser] = useState<boolean>(false)

  const handleCloseForm = (data: any) => {
    props.handleClose(data)
  }

  const handleSubmit = async (data: any) => {
    setProcessing(true)
    if (data.user) data.user = reactSelectService.formatReactSelectResponse(data.user)

    const userId = props.editData?._id ?? data.user

    const userResponse = await userService.insertOrUpdate(
      {
        id: userId,
        company: props.company._id,
        admin_company: superUser
      },
      `update/${userId}`
    )

    if (userResponse) {
      screenNotifications.fireToast(
        {
          message: `${t('modules.modal_company_users.form.success')}`,
        },
        {
          position: 'bottom-right',
        }
      )
      setProcessing(false)
      handleCloseForm({status: 'saved'})
    }
    setProcessing(false)
  }

  useEffect(() => {
    const users = props.users.reduce((accum: Array<any>, element: any) => {
      accum.push({value: element._id, label: `${element.profile?.first_name} ${element.profile?.last_name}`})
      return accum
    }, [])
    setListOfUsers(users)
  }, [props.users])

  useEffect(() => {
    if (props.editData) {
      setSuperUser(props.editData?.admin_company ?? false)
    } else {
      setSuperUser(false)
    }
  }, [props.editData])

  return(
    <div className='add_new_company_form-component'>
      <form onSubmit={formHook.handleSubmit(handleSubmit)} className="">
        <div className="row">
          {!processing && (
            <div className="col-12 d-flex">
              <TextComponent
                type='subtitle'
              >
                {props.editData ? 'Editar colaborador' : 'Agregar colaborador'}
              </TextComponent>
              <button
                className='btn btn-link btn-sm ml-auto'
                data-tip={t('modules.modal_company_users.actions.close_form')}
                onClick={() => handleCloseForm({status: 'closed'})}
              >
                <AiFillCloseCircle size="20px" color={colors.primary} />
              </button>
            </div>
          )}
          <div className="col-12">
            {!props.editData ?
            <div className="form-group">
              <label htmlFor='user'>{t('modules.modal_company_users.form.user')}</label>
              <ReactSelectComponent
                identifier='user'
                options={listOfUsers}
                formHooks={formHook}
                defaultValue={[]}
                isMulti={false}
                required={true}
              />
              {formHook.errors.user && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
            </div>
            :
              <TextComponent
                type='text'
                style={{ color: 'black', fontSize: '1.3rem', margin: '10px 0px' }}
              >
                {props.editData?.profile?.first_name} {props.editData?.profile?.last_name}
              </TextComponent>
            }
          </div>
          <div className="col-12">
            <div className="d-flex flex-column gap-1">
              <label>Super usuario</label>
              <SwitchComponent
                checked={superUser}
                onClick={() => setSuperUser(!superUser)}
                size='large'
              />
            </div>
          </div>
          <div className="col-12">
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit' disabled={processing}>
                  {processing && (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;</>)}
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddNewCompanyFormModuleLayout
